import styled from 'styled-components';
import { Container as InvoicesListContainer } from '../InvoicesList/InvoicesList.styles';
import {
  Item as InvoiceListItem,
  Content,
  TopRow,
  BottomRow,
  Icons,
  DownloadSlot,
  Chevron,
} from '../InvoiceListItem/InvoiceListItem.styles';

export const Container = InvoicesListContainer;

export const Item = styled(InvoiceListItem)`
  cursor: default;
`;

export { Content, TopRow, BottomRow, Icons, DownloadSlot, Chevron };
